import { AxiosInstance } from 'axios'
import axiosInstance from '../index'

class PasswordApi {
    private axios: AxiosInstance

    constructor(axios: AxiosInstance) {
      this.axios = axios
    }

    public async sendEmail(address: string) {
      await this.axios.post('/password/recover', { email: address })
    }

    public async resetPassword(password: string, token: string) {
      await this.axios.post('/password/reset', { password, token })
    }
}

export const passwordApi = new PasswordApi(axiosInstance)
